import { makeStyles, alpha } from '@material-ui/core/styles';
import BGIMG from './images/card-bg.jpeg';

const themeStyles = makeStyles((theme) => ({
  root: {},
  containerWrapper: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 7,
      paddingRight: 7
    }
  },
  jobCard: {
    transition: '1s all ease-in-out'
  },
  hideCard: {
    transform: 'scale(0)',
    opacity: 0
  },
  appCardWrapper: {
    overflowY: 'auto',
    overflowX: 'hidden',
    width: '100%',
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 50
  },
  tabHide: {},
  tabShow: {
    marginTop: 50,
    [theme.breakpoints.down('lg')]: {
      paddingTop: 0
    }
  },
  blankId: {
    color: '#fff',
    textAlign: 'center',
    padding: 20,
    background: '#212B36'
  },
  tabMainWrapper: {
    background: '#fff',
    position: 'fixed',
    zIndex: 1199,
    width: '100%',
    top: 0,
    [theme.breakpoints.down('lg')]: {
      top: 60
    },
    [theme.breakpoints.down('sm')]: {
      left: 0,
      right: 0
    }
  },
  cardMediaWrap: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    paddingTop: 'calc(100% * 7 / 30)',
    '&:before': {
      top: 0,
      zIndex: 9,
      content: "''",
      width: '100%',
      height: '100%',
      position: 'absolute',
      backdropFilter: 'blur(3px)',
      borderTopLeftRadius: theme.shape.borderRadiusMd,
      borderTopRightRadius: theme.shape.borderRadiusMd,
      backgroundColor: alpha(theme.palette.primary.darker, 0.72)
    }
  },
  Irrelevant: {
    '&:before': {
      // backgroundImage: `linear-gradient(0deg, #3f51b53d, #3f51b570), url(${BGIMG}) !important`
      backgroundImage: `linear-gradient(0deg, #ff00ff26, #ff00ff26), url(${BGIMG}) !important`
    }
  },
  Relevant: {
    '&:before': {
      // backgroundImage: `linear-gradient(0deg, #ffeb3b78, #ffeb3b66), url(${BGIMG}) !important`
      backgroundImage: `linear-gradient(0deg, #ee82ee21, #ee82ee21), url(${BGIMG}) !important`
    }
  },
  New: {
    '&:before': {
      // backgroundImage: `linear-gradient(0deg, #ff572240, #ff57224d), url(${BGIMG}) !important`
      backgroundImage: `linear-gradient(0deg, #695acd29, #695acd29), url(${BGIMG}) !important`
    }
  },
  NoResponse: {
    '&:before': {
      // backgroundImage: `linear-gradient(0deg, #52525245, #0000003d), url(${BGIMG}) !important`
      backgroundImage: `linear-gradient(0deg, #8b008b2b, #8b008b2b), url(${BGIMG}) !important`
    }
  },
  'Follow-up': {
    '&:before': {
      // backgroundImage: `linear-gradient(0deg, #e91e6338, #e91e6338), url(${BGIMG}) !important`
      backgroundImage: `linear-gradient(0deg, #8a2be226, #8a2be226), url(${BGIMG}) !important`
    }
  },
  Purchase: {
    '&:before': {
      // backgroundImage: `linear-gradient(0deg, #4caf5052, #8bc34a6b), url(${BGIMG}) !important`
      backgroundImage: `linear-gradient(0deg, #4b00821f, #4b00821f), url(${BGIMG}) !important`
    }
  },
  avatarShape: {
    zIndex: 10,
    bottom: -26,
    position: 'absolute'
  },
  purchaseNotes: {
    paddingRight: 7,
    paddingLeft: 7,
    paddingTop: 8,
    paddingBottom: 8
  },
  leadInfoWrapper: {
    padding: '20px 10px',
    minHeight: 225,
    [theme.breakpoints.down('sm')]: {
      minHeight: 'inherit'
    }
  },
  jobCardLoadingWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgb(0 0 0 / 61%)',
    zIndex: 20
  },
  addLeadFabWrapper: {
    right: 30,
    bottom: 30,
    position: 'fixed',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    zIndex: 100
  },
  addNewLeadBtn: {
    backgroundColor: 'green',
    color: '#fff',
    marginTop: 15,
    '&:hover': {
      background: '#074407'
    }
  },
  addNewLeadLabel: { paddingRight: 5 },
  addNewLeadappBar: {
    position: 'fixed'
  },
  addNewLeadtitle: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    flex: 1,
    [theme.breakpoints.down('md')]: {
      fontSize: 14
    }
  },
  addNewLeadFormWrapper: {
    width: 400,
    margin: '25px auto',
    marginTop: 100,
    [theme.breakpoints.down('md')]: {
      width: '90%'
    }
  },
  fieldWrapper: {
    marginBottom: 20
  },
  addLeadSelect: {
    textAlign: 'right'
  },
  statisticsWrapper: {
    width: 400,
    margin: '25px auto',
    marginTop: 100,
    [theme.breakpoints.down('md')]: {
      width: '90%'
    }
  },
  statisticsinnerWrapper: {
    backgroundColor: '#1b2229',
    padding: 20,
    marginTop: 10,
    marginBottom: 10,
    borderRadius: 10
  },
  statisticsTitle: {
    marginBottom: 20,
    color: '#a852ff'
  },
  statisticsRow: {
    borderBottom: '1px solid #eee',
    padding: '10px 5px'
  },
  labelText: {
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    }
  },
  valueText: {
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      maxWidth: '80%',
      wordBreak: 'break-word'
    }
  },
  mianModalWrapper: {
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column'
    }
  },
  modalIframeWrapper: {
    [theme.breakpoints.down('lg')]: {
      position: 'relative',
      overflow: 'hidden',
      width: '100%',
      paddingTop: '56.25%'
    }
  },
  modalIframe: {
    width: 1200,
    height: 600,
    [theme.breakpoints.down('lg')]: {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 50,
      right: 0,
      width: '100%',
      height: '100%'
    }
  }
}));

export default themeStyles;
